import React, { useRef, useState } from 'react';
import { Layout, Menu, Row, Modal, MenuProps } from 'antd';
import { Link, useHistory } from "react-router-dom";
import { useAppDispatch } from "../../../redux/hooks";
import { logout } from "../../../redux/authSlice";
import {
    SearchOutlined, MenuUnfoldOutlined, MenuFoldOutlined
} from '@ant-design/icons';
import './styles.less'
import './style.css'
import "antd/dist/antd.css";
// import VnpaySvg from '@/assets/media/brands/logo.svg'
import VnpayInvoiceSvg from '../../../assets/media/brands/logo.svg'
import "../AuthLayout/AuthLayoutHeader/auth-layout-header.css";
import logoImg from "../../../assets/media/brands/logo.svg";
import logoBackground from "../../../assets/media/img/login-bg.jpg";
import caretDownImg from "../../../assets/media/icons-color/subdefault/default/carret-down.svg";
import userImg from "../../../assets/media/img/avatar.svg";
import keyImg from "../../../assets/media/icons-color/subdefault/default/key.svg";
import logoutImg2 from "../../../assets/media/img/logout.svg";
import { useOnClickOutside } from "usehooks-ts";
import UserApi from "../../../services/api/UserApi";


type MenuItem = Required<MenuProps>['items'][number];

interface AuthLayoutProps {
    children: React.ReactNode;
}

const { Header, Content, Footer, Sider } = Layout;

function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group',
): MenuItem {
    return {
        key,
        icon,
        children,
        label,
        type,
    } as MenuItem;
}
const items: MenuProps['items'] = [
    getItem('TRA CỨU TRUYỀN NHẬN DỮ LIỆU', '1', <SearchOutlined />)
]
const AuthLayout: React.FC<AuthLayoutProps> = props => {

    const history = useHistory();
    const ref = useRef(null);
    const dispatch = useAppDispatch();

    const userInfo: any = sessionStorage.getItem("userInfo");
    let [collapsed, setCollapsed] = useState<any>(false);
    const [showDropdown, setShowDropdown] = useState(false);



    const handleUpdatePassword = () => {
        history.push("/update-password");
        if (showDropdown) {
            setShowDropdown(false);
        }
    };

    const handleLogout = async () => {
        try {
            await UserApi.logOut();
            dispatch(logout());
            history.push("/auth/login");
            if (showDropdown) {
                setShowDropdown(false);
            }
        } catch (err: any) {
            if (err && err?.response?.data?.code !== "00") {
                Modal.error({ title: "Đăng xuất không thành công" });
            } else {
                Modal.error({ title: err?.response?.data?.message });
                console.log(err);
            }
        }

    };

    const handleAccountInfo = () => {
        history.push("/account-info");
        if (showDropdown) {
            setShowDropdown(false);
        }
    };


    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);

    };

    const toggleSider = () => {
        setCollapsed(!collapsed)
    };

    const handleClickOutside = () => {
        if (showDropdown) {
            setShowDropdown(false);
        }
    };
    const navigateDataTransmission = () =>{
        history.push('/data-transmission')
    }
    useOnClickOutside(ref, handleClickOutside)
    return (
        <>
            <Layout>
                <Sider
                    theme={"light"}
                    breakpoint="lg"
                    collapsedWidth="0"
                    width={250}
                    // collapsible
                    collapsed={collapsed}
                    onCollapse={value => setCollapsed(value)}
                >
                    <Menu
                        theme="light"
                        mode="inline"
                        defaultSelectedKeys={['1']}
                        onClick={navigateDataTransmission}
                        items={items} style={{ paddingTop: '60px' }} />

                </Sider>
                <Layout>
                    <Header className="site-layout-sub-header-background header-layout" style={{ padding: 0 }}>
                        <>
                            <Row justify="end">
                                <div id="kt_header" className="header header-fixed">
                                    <div className="d-flex align-items-stretch header-inner">
                                        <div className="brand flex-column-auto" id="kt_brand">
                                            <Link to="/data-transmission">
                                                <div className="brand-logo" >
                                                    <img
                                                        alt="Logo"
                                                        src={logoImg}
                                                    />
                                                </div>
                                            </Link>
                                            {React.createElement(
                                                collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                                                {
                                                    className: 'trigger',
                                                    onClick: toggleSider,
                                                })}
                                        </div>
                                        <div className="w-100 justify-content-between d-flex">
                                            <div
                                                className="header-menu-wrapper header-menu-wrapper-left"
                                                id="kt_header_menu_wrapper"
                                            >
                                                <div
                                                    id="kt_header_menu"
                                                    className="align-items-center header-menu header-menu-mobile header-menu-layout-default"
                                                >
                                                    <div className="pl-32 h4 text-primary">
                                                        Cổng tra cứu truyền nhận hóa đơn điện tử VNPAY TVAN
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="topbar" ref={ref}>
                                                <div className="dropdown avatar-dropdown">
                                                    <div
                                                        className="topbar-item"
                                                        data-toggle="dropdown"
                                                        data-offset="10px,0px"
                                                        onClick={toggleDropdown}
                                                    >
                                                        <div className="btn btn-icon w-auto d-flex align-items-center btn-lg px-2">
                                                            <div className="avatar-text">
                                                                <div className="h5 text-dark-50">
                                                                    Xin chào!
                                                                </div>
                                                                <div className="p font-weight-500" >
                                                                    {userInfo ? userInfo : 'Admin'}
                                                                </div>
                                                            </div>
                                                            <div className="avatar-image" style={{
                                                                backgroundImage:
                                                                    "url(" + logoBackground + ")",
                                                            }}></div>
                                                            <div className="avatar-arrow">
                                                                <img
                                                                    src={caretDownImg}
                                                                    alt=""
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={'dropdown-menu p-0 m-0 dropdown-menu-anim-up dropdown-menu-md dropdown-menu-right ' + (showDropdown ? 'show' : '')}>
                                                        <ul className="navi navi-hover py-4">
                                                            <li
                                                                className="navi-item"
                                                                onClick={handleAccountInfo}
                                                            >
                                                                <a className="navi-link" href="#/">
                                                                    <img
                                                                        src={userImg}
                                                                        alt=""
                                                                        className="navi-icon"
                                                                    />
                                                                    <span className="navi-text">
                                                                        Thông tin tài khoản
                                                                    </span>
                                                                </a>
                                                            </li>
                                                            <li
                                                                className="navi-item"
                                                                onClick={handleUpdatePassword}
                                                            >
                                                                <a className="navi-link" href="#/">
                                                                    <img
                                                                        src={keyImg}
                                                                        alt=""
                                                                        className="navi-icon"
                                                                    />
                                                                    <span className="navi-text">
                                                                        Đổi mật khẩu
                                                                    </span>
                                                                </a>
                                                            </li>

                                                            <li className="navi-item">
                                                                <a className="navi-link" onClick={handleLogout} href="#/">
                                                                    <img
                                                                        src={logoutImg2}
                                                                        alt=""
                                                                        className="navi-icon"
                                                                    />
                                                                    <span className="navi-text">
                                                                        Đăng xuất
                                                                    </span>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                        </>

                    </Header>
                    <Content style={{ margin: '24px 16px 0' }}>
                        {props?.children}
                    </Content>
                    <Footer className="footer-layout">
                         <span>© 2023 VNPAY TVAN. Cổng tra cứu truyền nhận hóa đơn điện tử VNPAY TVAN</span>                                   
                    </Footer>
                </Layout>
            </Layout>
        </>
    );
};
export default AuthLayout;
